//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import $ from "jquery";

(function() {
  const curalate = angular.module('curalate');

    /**
     * Used to prevent a child element from scrolling an outer element.
     * In particular, this is used by the fullscreen sidebar implementation, to keep sidebar scrolls from scrolling the main page.
     */
  curalate.directive('ngScrollLock', ['$window', function($window) {
    return {
      restrict: 'A',
      link(scope, element) {
                // Based loosely on jqueryUI's scrollParent method.
                // Should detect whether the given element is directly scrollable.
        function isScrollable(el) {
          return /(auto|scroll)/.test($window.getComputedStyle(el, 'overflow')
                                              + $window.getComputedStyle(el, 'overflow-y')
                                              + $window.getComputedStyle(el, 'overflow-x'));
        }

        const scrollHandler = function scrollHandler(event) {
          const target = event.target;
          function getNextScroller(el) {
                        // If this is the encompassing parent element, then there is no valid next scroller.
            return el !== element[0] && $(el).scrollParent()[0];
          }

                    // Checks the element to see if it is scrolled all the way to the top/bottom, or if it will scroll naturally.
                    // Recursively checks until we're at the target "scroll-locked" element.
                    //
                    // Returns true if we need to prevent default (cancel the scroll)
          function checkElementScroll(el, deltaY) {
                        // If we're out of scrolling elements, or out of deltaY to allocate, we're done.
            if (!el) {
              return true;
            }

            const scrollTop = el.scrollTop;
                        // Todo: expand this check to use deltaY comparisons to check for scrolls that would go past the end of the container
                        // But beware the delta value semantics: https://developer.mozilla.org/en-US/docs/Web/Events/wheel#The_delta_values

                        // Check if this element is going to scroll during this scroll event.
            if (
                            (scrollTop === 0 && deltaY < 0) // Element is scrolled to the top, and we're scrolling up.
                            || (deltaY > 0 && scrollTop + el.clientHeight === el.scrollHeight) // Element is scrolled to the bottom, and we're scrolling down
                        ) {
                            // This element is not going to scroll;
                            // Recurse to the next scrolling element to check.
              return checkElementScroll(getNextScroller(el), deltaY);
            }

                        // else : this element will scroll, so we're done.
            return false;
          }

                    // If the current target of the scroll event is scrollable, test it for scroll conditions.
                    // Otherwise, use its scrollParent.
          if (checkElementScroll(isScrollable(target) ? target : getNextScroller(target), event.deltaY)) {
            event.preventDefault();
          }
        };

        element[0].addEventListener('wheel', scrollHandler);

        scope.$on('$destroy', () => {
          element[0].removeEventListener('wheel', scrollHandler);
        });
      },
    };
  }]);
})();
